import { DayCardSkeleton } from './day-card-skeleton'

function DaySliderSkeleton() {
  return (
    <div className="flex h-[32px] items-center gap-[20px] rounded-full bg-app-grey-200 px-[20px]">
      {Array.from({ length: 7 }, (_, i) => (
        <div
          // biome-ignore lint/suspicious/noArrayIndexKey: skeleton
          key={i}
          className="size-[12px] animate-pulse rounded-full bg-app-grey-300"
        />
      ))}
    </div>
  )
}

function GridSkeleton() {
  return (
    <div className="grid w-full max-w-[1268px] grid-cols-[repeat(auto-fill,minmax(280px,1fr))] gap-3 pb-16">
      {Array.from({ length: 7 }, (_, i) => (
        <div
          // biome-ignore lint/suspicious/noArrayIndexKey: skeleton
          key={i}
          className="relative aspect-[308/366] overflow-hidden rounded-[60px] bg-app-grey-200"
        >
          <div
            className="pointer-events-none absolute inset-0 -skew-x-12"
            style={{
              background:
                'linear-gradient(90deg, transparent 0%, rgba(255,255,255,0.5) 50%, transparent 100%)',
              animation: 'skeleton-shimmer 1.8s ease-in-out infinite',
            }}
          />
        </div>
      ))}
      {/* QR card skeleton */}
      <div className="relative aspect-[308/366] overflow-hidden rounded-[60px] bg-app-grey-200">
        <div
          className="pointer-events-none absolute inset-0 -skew-x-12"
          style={{
            background:
              'linear-gradient(90deg, transparent 0%, rgba(255,255,255,0.5) 50%, transparent 100%)',
            animation: 'skeleton-shimmer 1.8s ease-in-out infinite',
          }}
        />
      </div>
    </div>
  )
}

export function PlanPageSkeleton() {
  return (
    <>
      {/* Mobile */}
      <div className="mx-auto flex h-full max-w-lg flex-col lg:hidden">
        <div className="flex min-h-0 flex-1 flex-col gap-[18px] pt-[16px]">
          <div className="min-h-0 flex-1">
            <div className="h-full px-[24px]">
              <DayCardSkeleton />
            </div>
          </div>
        </div>
        <div className="flex justify-center pt-[16px] pb-[16px]">
          <DaySliderSkeleton />
        </div>
      </div>

      {/* Desktop */}
      <div className="hidden h-full flex-col items-center px-8 pt-2 lg:flex">
        <GridSkeleton />
      </div>
    </>
  )
}

export function PlanPageSkeletonSuspense() {
  return (
    <>
      {/* Mobile */}
      <div className="mx-auto flex h-full max-w-lg flex-col lg:hidden">
        <div className="flex min-h-0 flex-1 flex-col gap-[18px] pt-[16px]">
          <div className="mx-auto h-[40px] w-[124px] animate-pulse rounded-full bg-app-grey-200" />
          <div className="min-h-0 flex-1">
            <div className="h-full px-[24px]">
              <DayCardSkeleton />
            </div>
          </div>
        </div>
        <div className="flex justify-center pt-[16px] pb-[16px]">
          <DaySliderSkeleton />
        </div>
      </div>

      {/* Desktop */}
      <div className="hidden h-full flex-col items-center px-8 pt-2 lg:flex">
        <div className="flex w-full max-w-[1268px] items-center justify-between pb-4">
          <div className="flex flex-col gap-1 p-4">
            <div className="h-4 w-20 animate-pulse rounded bg-app-grey-200" />
            <div className="h-5 w-56 animate-pulse rounded bg-app-grey-200" />
          </div>
          <div className="h-[40px] w-[124px] animate-pulse rounded-full bg-app-grey-200" />
        </div>
        <GridSkeleton />
      </div>
    </>
  )
}
